export const contactFormComponent = {
  key: 'contactFormComponent',
  name: 'Contact Form Component',
  siteIdentifier: 'global',

  productQuestionLabel:
    'Which product do you have a question about? (optional)',
  pleaseChooseDefaultSelectOption: 'Please Choose',
  questionOrCommentLabel: 'Question or Comment',
  proveYouAreNotRobot: 'Please check the box to prove you are not a robot!',
  questionLabel: 'Question',
  phoneNumberLabel: 'Phone Number',
  allFieldsRequired: 'Unless indicated, all fields are required',
  nameLabel: 'Name',
  emailLabel: 'Email',
  submitButton: 'Submit',
  recaptchaMessage: 'This site is protected by reCAPTCHA.',
};

export const formMessageBoxComponent = {
  key: 'formMessageBoxComponent',
  name: 'Form Message Box Component',
  siteIdentifier: 'global',

  enableCookiesForLoginMessage:
    'There was a problem logging in, please check that your browser is set to allow 3rd-party cookies for this site.',
};

export const klaviyoFormComponent = {
  key: 'klaviyoFormComponent',
  name: 'Klaviyo Form Component',
  siteIdentifier: 'global',

  captchaCompleteMessage:
    'Complete the CAPTCHA above, then click Submit again to finish.',
  captchaIframeTitle: 'Klaviyo CAPTCHA Challenge',
  submittingLabel: 'Submitting...',
  addressSuggestionRequiredMessage:
    'Please select an address from the suggestions.',
  recaptchaUnavailableMessage:
    'Unable to verify reCAPTCHA. Please try again later.',
  recaptchaChallengeRequiredMessage:
    'Please complete the reCAPTCHA challenge to continue.',
  fieldRequiredMessage: '{label} is required',
  invalidPhoneNumberMessage: 'Enter a valid phone number',
  invalidEmailMessage: 'Invalid email',
  checkboxRequiredMessage: 'Required',
  errorAlertTitle: 'Error',
  winBackTitle: 'Finish Scheduling Your Free Quote',
  winBackLoadingMessage: 'Hang tight while we retrieve your information...',
  klaviyoFormSubmitErrorMessage:
    'We were unable to submit your form. Please try again or contact support if the issue persists.',
  leadCreationWinBackFailedErrorMessage:
    'Oops! The link you clicked has expired or is invalid. Please use the form below to provide your information.',
  reCaptchaFailedErrorMessage:
    'Oops! We had trouble verifying your request. Please fill the form below.',
  winBackErrorAlertTitle: "We're sorry",
  dateFormatDescription: 'Date format: day, month, year, separated by dots',
  stepLoadedAnnouncement:
    '{stepName} loaded. Step {stepNumber} of {totalSteps}.',
  stepLoadedAnnouncementCompleted:
    '{stepName} loaded. Step {stepNumber} of {totalSteps}. Form completed.',
  formSubmittedAnnouncement: 'Scheduling form loading.',
  schedulerLoadedAnnouncement:
    'Scheduling form loaded. Please fill scheduling form below.',
  appointmentConfirmedAnnouncement: 'Appointment confirmed.',
  schedulerSubmittingAnnouncement:
    'Scheduler form submitted, waiting for approval.',
  returningToFormAnnouncement: 'An error occurred. Returning to the form.',
  schedulingSkippedAnnouncement: 'Your information has been submitted.',
  addressSuggestionAnnouncement:
    '{count} address suggestions available. Use up and down arrow keys to navigate.',
  addressSuggestionAnnouncementSingular:
    '{count} address suggestion available. Use up and down arrow keys to navigate.',
  submitButtonLabel: 'Continue',
};
